var __jsx = React.createElement;
import React from 'react';
import { ImageAnchorSelector } from 'components/common/ImageAnchorSelector';
import { StyledReactCrop } from './ImageCropper.style';

var ImageCropper = function ImageCropper(_ref) {
  var imgUrl = _ref.imgUrl,
      crop = _ref.crop,
      handleCrop = _ref.handleCrop,
      handleImageLoaded = _ref.handleImageLoaded,
      setImageAnchor = _ref.setImageAnchor,
      imageAnchor = _ref.imageAnchor,
      displayedRatio = _ref.displayedRatio,
      displayAnchor = _ref.displayAnchor;
  return __jsx(StyledReactCrop, {
    src: imgUrl,
    crop: crop,
    onChange: handleCrop,
    onImageLoaded: handleImageLoaded,
    renderSelectionAddon: function renderSelectionAddon() {
      return __jsx(React.Fragment, null, displayAnchor === true && __jsx(ImageAnchorSelector, {
        setImageAnchor: setImageAnchor,
        imageAnchor: imageAnchor,
        crop: crop,
        displayedRatio: displayedRatio
      }));
    }
  });
};

export default ImageCropper;